import React from 'react';
import ContractsIcon from './ContractsIcon'; // Reusing ContractsIcon as per HTML graphic

// EvaluationsIcon is visually the same as ContractsIcon in the provided HTML.
// So, we re-export ContractsIcon or wrap it if specific props are needed for EvaluationsIcon in the future.
const EvaluationsIcon = (props) => <ContractsIcon {...props} />;

export default EvaluationsIcon;